import styled from "styled-components";

export const ResultsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin: 1em 0;
`;
